import { isValid, parse } from 'date-fns'
import * as Yup from 'yup'
import { DATE_FORMAT_FRONT_SHORT, FR_SHORT_DATE_REGEX } from '../../../misc/date.utilities'
import {
  BIRTH_PLACE_CODE_REGEX,
  FIRST_NAME_REGEX,
  IdentityStatus,
  NAME_REGEX,
  PHONE_REGEX,
} from '../../../model/Patient'
import { ObjectSchema } from 'yup'
import { computeFirstNames } from './PatientForm.utils'
import { formatNamesList } from './IdentityStatusBlock/IdentityStatusBlock.utils'

export const getValidationSchema = (): ObjectSchema => {
  return PatientValidationSchema
}

export const PatientValidationSchema = Yup.object().shape({
  birthFirstName: Yup.string()
    .required('Obligatoire')
    .matches(
      FIRST_NAME_REGEX,
      'Seules les lettres sans accent, tirets, apostrophes et espaces sont autorisés',
    )
    .when(
      ['identityStatus', 'otherFirstNames'],
      (identityStatus: IdentityStatus, otherFirstNames: string, schema: Yup.StringSchema) => {
        if (identityStatus.insiStatus.checked === 'VALIDATED') {
          return schema.test(
            'insi check firstnames coherence',
            "Le prénom de naissance n'est pas conforme au retour INSi",
            (currentValue: string) => {
              if (!otherFirstNames) {
                return true
              }
              const securedFirstNames = computeFirstNames(otherFirstNames?.toLocaleLowerCase())
              return formatNamesList(securedFirstNames).indexOf(currentValue) !== -1
            },
          )
        } else {
          return schema
        }
      },
    ),
  birthLastName: Yup.string()
    .required('Obligatoire')
    .matches(
      NAME_REGEX,
      'Seules les lettres majuscules sans accent, tirets, apostrophes et espaces sont autorisés',
    ),
  birthDate: Yup.string()
    .test('birthDate', 'La date ne respecte pas le format "jj/mm/aaaa"', (date) => {
      return (
        isValid(parse(date, DATE_FORMAT_FRONT_SHORT, new Date())) &&
        date.match(FR_SHORT_DATE_REGEX) !== null
      )
    })
    .required('Obligatoire'),
  sex: Yup.string().required('Obligatoire'),
  birthPlaceCode: Yup.string()
    .matches(
      BIRTH_PLACE_CODE_REGEX,
      'Saisir un code lieu de naissance valide (ex: 75110, 2A011, ...)',
    )
    .required('Obligatoire'),
  profession: Yup.string(),
  email: Yup.string().email('Format invalide'),
  telephone1: Yup.string().matches(PHONE_REGEX, 'Chiffres et "+" uniquement'),
  telephone2: Yup.string().matches(PHONE_REGEX, 'Chiffres et "+" uniquement'),
  doctor: Yup.string(),
  inseeNumber: Yup.string(),
  healthInsuranceNumber: Yup.string(),
  note: Yup.string(),
  address: Yup.object()
    .shape({
      street2: Yup.string().nullable(),
      street: Yup.string().nullable(),
      zipCode: Yup.string().nullable(),
      city: Yup.string().nullable(),
      country: Yup.string().nullable(),
    })
    .nullable(),
})
